import { render, staticRenderFns } from "./UploadMaterail.vue?vue&type=template&id=4952cb8f"
import script from "./UploadMaterail.vue?vue&type=script&lang=js"
export * from "./UploadMaterail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4952cb8f')) {
      api.createRecord('4952cb8f', component.options)
    } else {
      api.reload('4952cb8f', component.options)
    }
    module.hot.accept("./UploadMaterail.vue?vue&type=template&id=4952cb8f", function () {
      api.rerender('4952cb8f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UploadMaterail/UploadMaterail.vue"
export default component.exports